var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFiltersBullet = function SvgSysFiltersBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.552 13.688H1.596a.5.5 0 0 1 0-1h1.956a2.159 2.159 0 0 1 4.2 0h6.845a.5.5 0 0 1 0 1H7.752a2.159 2.159 0 0 1-4.2 0Zm.939-.5a1.156 1.156 0 0 0 1.385 1.134 1.157 1.157 0 0 0 .419-2.1 1.159 1.159 0 0 0-1.804.963v.002Zm5.09-4.512H1.597a.5.5 0 0 1 0-1H9.58a2.16 2.16 0 0 1 4.2 0h.814a.5.5 0 0 1 0 1h-.815a2.158 2.158 0 0 1-4.2 0Zm.939-.5a1.16 1.16 0 1 0-.001-.002v.002Zm-9.424-4.94A2.16 2.16 0 0 1 2.98 1.088 2.159 2.159 0 0 1 5.346 2.69h9.253a.5.5 0 0 1 0 1H5.366a2.161 2.161 0 0 1-2.34 1.686 2.161 2.161 0 0 1-1.93-2.143v.002Zm1 0a1.158 1.158 0 0 0 .715 1.073c.212.088.445.112.67.068a1.161 1.161 0 0 0-.225-2.299 1.163 1.163 0 0 0-1.158 1.156l-.002.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M11.969 7.626a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.969.026a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 7.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"
  })));
};
export default SvgSysFiltersBullet;